import { browser } from '../../../common/services/browser';
import { DEVICE_CHANGE_EVENT } from '../constants';
import { debounce } from 'lodash';
import { restoreCurrentDevices } from './current-devices';
import { updateDevices } from './devices';
export const subscribeForDeviceChange = () => (dispatch) => {
    if (browser.supportsOnDeviceChange()) {
        window.navigator.mediaDevices.addEventListener(DEVICE_CHANGE_EVENT, debounce(() => dispatch(updateDevices()), 100) // can be fired twice
        );
    }
};
export const devicesInitAction = () => (dispatch) => {
    dispatch(subscribeForDeviceChange());
    dispatch(restoreCurrentDevices());
    dispatch(updateDevices());
};
